import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import AssociationService from "./NewsRepoterSrvice";


export const getAssociations = createAsyncThunk("Association/get-Associations", async (thunkAPI) => {
  try {
    return await AssociationService.getAssociations();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createAssociations = createAsyncThunk(
  "Association/create-Associations",
  async (AssociationData, thunkAPI) => {
    try {
      return await AssociationService.createAssociations(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAssociation = createAsyncThunk(
  "Association/get-Association",
  async (id, thunkAPI) => {
    try {
      return await AssociationService.getAssociation(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAssociation = createAsyncThunk(
  "Association/update-Association",
  async (brand, thunkAPI) => {
    try {
      return await AssociationService.updateAssociation(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAAssociation = createAsyncThunk(
  "Association/delete-Association",
  async (id, thunkAPI) => {
    try {
      return await AssociationService.deleteAssociation(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Associations: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "Association",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAssociations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAssociations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Associations = action.payload.data;
      })
      .addCase(getAssociations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createAssociations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createAssociations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdAssociation = action.payload;
      })
      .addCase(createAssociations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getAssociation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAssociation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.associationtype = action.payload.data.type;
        state.associationemail= action.payload.data.email;
        state.associationName= action.payload.data.name;
       
        
        
        
      })
      .addCase(getAssociation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAssociation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAssociation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedAssociation = action.payload;
      })
      .addCase(updateAssociation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAAssociation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAAssociation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedAssociation = action.payload;
      })
      .addCase(deleteAAssociation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
